import React, { useState } from 'react';
import { BellRing, BellOff } from 'lucide-react';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { toast } from 'sonner';

export const PushNotificationButton = () => {
  const { isSupported, isSubscribed, subscribe } = usePushNotifications();
  const [loading, setLoading] = useState(false);

  if (!isSupported) return null;

  const handleClick = async () => {
    if (isSubscribed) {
      toast.info('Ya tienes las notificaciones push activadas');
      return;
    }
    setLoading(true);
    const success = await subscribe();
    setLoading(false);
    if (success) {
      toast.success('Notificaciones push activadas.');
    } else {
      toast.error('No se pudieron activar. Verifica permisos del navegador.');
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className={`p-1.5 rounded-md ${isSubscribed ? 'text-emerald-400' : 'text-orange-400 animate-pulse'}`}
      data-testid="push-notification-btn"
    >
      {isSubscribed ? <BellRing className="h-4 w-4" /> : <BellOff className="h-4 w-4" />}
    </button>
  );
};
